// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2226":"fb0562b08a214bc7","2406":"b7fb9e676b8313e7","2475":"d9359d55c91550e4","3176":"2b6de09a7ba36f00"}[chunkId] + ".css";
};